export function setLoading( state ){
    return {
        type: "SET_LOADING",
        payload: state
    }
}

export function setApiKey( key ){
    return {
        type: "SET_API_KEY",
        payload: key
    }
}


// WEBPACK FOOTER //
// ./src/components/theme/actions.js